// extracted by mini-css-extract-plugin
export default {"wrapper":"_6f93a480","bottomWrapper":"_85a3de0f","relatedSearchesHeader":"_f95e78bb"};